var map = {
	"./account.js": "a9f0",
	"./cart.js": "d049",
	"./goods.js": "56a3",
	"./home.js": "1a2c",
	"./index.js": "c270",
	"./login.js": "783e",
	"./news.js": "0e5c",
	"./zone.js": "febb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f008";